import { render, staticRenderFns } from "./TestEditor.vue?vue&type=template&id=12387c94&"
import script from "./TestEditor.vue?vue&type=script&lang=ts&"
export * from "./TestEditor.vue?vue&type=script&lang=ts&"
import style0 from "./TestEditor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports